import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PlatiOnlineComponent } from './components/plati-online/plati-online.component';
import { InterogariPlatiComponent } from './components/interogari-plati/interogari-plati.component';
import { AmenziAchitateComponent } from './components/amenzi-achitate/amenzi-achitate.component';
import { TaxeNedebitateAchitateComponent } from './components/taxe-nedebitate-achitate/taxe-nedebitate-achitate.component';
import { TokenComponent } from './token/token.component';
import { TokenGuard } from './layout/components/guards/token.guard';
import { PermissionsGuard } from './layout/components/guards/permissions.guard';
import { AdminSetariComponent } from './components/administrativ/admin-setari/admin-setari.component';
import { SettingsComponent } from './components/settings/settings.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/plati-online',
        pathMatch: 'full',
    },

    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'plati-online',
                component: PlatiOnlineComponent,
            },
            {
                path: 'interogari-plati',
                component: InterogariPlatiComponent,
            },
            {
                path: 'amenzi-achitate',
                component: AmenziAchitateComponent,
            },
            {
                path: 'taxe-nedebitate-achitate',
                component: TaxeNedebitateAchitateComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            }
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/plati-online',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
